import { Route, Routes, Navigate } from 'react-router-dom';
import HomePage from '../pages/properties/HomePage';
import PublishPropertyPage from '../pages/properties/publish-property/PublishPropertyPage';
import PublishOverviewPage from '../pages/properties/publish-property/PublishOverviewPage';
import PublishPropertyStructurePage from '../pages/properties/publish-property-children/PublishPropertyStructurePage';
import PublishPropertyTypePage from '../pages/properties/publish-property-children/PublishPropertyTypePage';
import PublishLocationPage from '../pages/properties/publish-property-children/PublishLocationPage';
import PublishConfirmLocationPage from '../pages/properties/publish-property-children/PublishConfirmLocationPage';
import PublishPropertyDataPage from '../pages/properties/publish-property-children/PublishPropertyDataPage';
import PublishPropertyServicePage from '../pages/properties/publish-property-children/PublishPropertyServicePage';
import PublishPropertyUploadPhotosPage from '../pages/properties/publish-property-children/PublishPropertyUploadPhotosPage';
import PublishPropertyDescriptionPage from '../pages/properties/publish-property-children/PublishPropertyDescriptionPage';
import PublishPropertyVisibilityPage from '../pages/properties/publish-property-children/PublishPropertyVisibilityPage';
import PublishPropertyPricePage from '../pages/properties/publish-property-children/PublishPropertyPricePage';
import PublishPropertyResumePage from '../pages/properties/publish-property-children/PublishPropertyResumePage';
import PublishPropertySuccessPage from '../pages/properties/publish-property/PublishPropertySuccessPage';
import PropertyDetailPage from '../pages/properties/publish-property/PropertyDetailPage';
import BrokerProfilePage from '../pages/properties/BrokerProfilePage';
import PublishPropertyTitlePage from '../pages/properties/publish-property-children/PublishPropertyTitlePage';
import ProtectedRoute from './ProtectedRoute';
import FavoritesPage from '../pages/properties/FavoritesPage';
import EditPropertyPage from '../pages/properties/edit-property/EditPropertyPage';
import PublishPropertyAmenitiesPage from '../pages/properties/publish-property-children/PublishPropertyAmenitiesPage';
import PhotosGallery from '../components/properties/PhotoGallery';
import UserPostsPage from '../pages/properties/user-posts/UserPostsPage';
import PDFPreviewPage from '../pages/PdfPreviewPage';
import ChatPage from '../pages/messages/ChatPage';
import PublishPropertyAssigneePage from '../pages/properties/publish-property-children/PublishPropertyAssigneePage';
import RealtorSelectionPage from '../pages/properties/publish-property-children/PublishRealtorTeamForAdmin';
import PropertyHunterAssignmentPage from '../pages/properties/publish-property-children/PublishHunterAssignment';
import ModulesPage from '../components/modules-page/ModulesPage';
import { PropertyCommissionPage } from '../pages/properties/publish-property-children/PublishPropertyCommissionPage';
import CampaignModal from '../pages/properties/publish-property/CampaignPage/CampaignPage';
import MainLayout from '../layouts/MainLayout';

const PropertiesRoutes = () => {
  return (
    <Routes>
      {/* Redirigir /properties a /properties/home */}
      <Route path="/" element={<Navigate to="home" />} />

      {/* Detalle de propiedad con galería de fotos anidada */}
      <Route path="property-detail/:id" element={<PropertyDetailPage />}>
        <Route path="photos" element={<PhotosGallery />} />
      </Route>

      <Route path="/realtor/:id" element={<BrokerProfilePage />} />


      {/* Vista previa de PDF */}
      <Route path="pdfpreview" element={<PDFPreviewPage />} />

      {/* Rutas protegidas */}
      <Route element={<ProtectedRoute />}>
        <Route 
          path="favorites" 
          element={<MainLayout showFilters={false} />} 
        >
          <Route index element={<FavoritesPage />} />
        </Route>
        
        <Route path="modules-page" element={<ModulesPage />} />
        <Route path="edit-property/:id" element={<EditPropertyPage />} />
        <Route path="user/posts" element={<UserPostsPage />} />

        {/* Rutas Mensajes */}
        <Route path="/messages" element={<ChatPage />} />
        <Route path="/messages/:conversationId" element={<ChatPage />} />

        {/* Publicación de propiedad */}
        <Route path="publish-property" element={<PublishPropertyPage />}>
          <Route path="overview" element={<PublishOverviewPage />} />
          <Route path="structure" element={<PublishPropertyStructurePage />} />
          <Route path="type" element={<PublishPropertyTypePage />} />
          <Route path="location" element={<PublishLocationPage />} />
          <Route path="confirm-location" element={<PublishConfirmLocationPage />} />
          <Route path="property-data" element={<PublishPropertyDataPage />} />
          <Route path="service" element={<PublishPropertyServicePage />} />
          <Route path="amenitie" element={<PublishPropertyAmenitiesPage />} />
          <Route path="upload-photos" element={<PublishPropertyUploadPhotosPage />} />
          <Route path="title" element={<PublishPropertyTitlePage />} />
          <Route path="description" element={<PublishPropertyDescriptionPage />} />
          <Route path="assignee" element={<PublishPropertyAssigneePage />} />
          <Route path="visibility" element={<PublishPropertyVisibilityPage />} />
          <Route path="hunter" element={<PropertyHunterAssignmentPage />} />
          <Route path='commission' element={<PropertyCommissionPage />} />
          <Route path="price" element={<PublishPropertyPricePage />} />
          <Route path="realtor-selection" element={<RealtorSelectionPage />} />
          <Route path="resume" element={<PublishPropertyResumePage />} />
          <Route path="finish" element={<PublishPropertySuccessPage />} />
        </Route>
      </Route>

      <Route path='campaign' element={<CampaignModal />} />

      {/* Rutas principales */}
      <Route path="home" element={<HomePage />} />
    </Routes>
  );
};

export default PropertiesRoutes;
